import { addOssWebpWithImg } from '@ecom/utils';
// 分转元  type:0-取全部 1-取整数 2-取小数
const fen2yuan = (fen: any, type: any = 0, zeroDeal: any = false) => {
    fen = fen + '';
    let num = parseFloat(fen);//避免字符串带有字母等符号
    if (isNaN(num) || num == 0) {
        if (type == 1) {
            return '0'
        }
        if (type == 2 && zeroDeal) {
            return ''
        }
        if (type == 2 && !zeroDeal) {
            return '.00'
        }
        if (zeroDeal) {
            return '0'
        }
        return '0.00';
    }
    num = num / 100;
    if (type == 1) {
        return (num2inte(num) + "");
    }
    let decimal = num2decimal(num) + "";
    if (zeroDeal) {
        if (decimal.split("")[1] == "0") {
            decimal = decimal.split("")[0];
        }
        if (decimal == '0') {
            decimal = ''
        }
    }
    if (decimal != "") {
        decimal = "." + decimal
    }

    if (type == 2) {
        return decimal;
    }
    let price = num2inte(num) + decimal;
    let priceFl = parseFloat(price);
    if (priceFl > 9999) {
        return (Math.floor(priceFl / 100) / 100) +
            '万'
    } else {
        return price;
    }


};

//大于1W变成万数
const num2w = (fen: any, type: any = 0, zeroDeal: any = false) => {
    const price = parseFloat(fen2yuan(fen, type, zeroDeal));
    if (price > 9999) {
        return (Math.floor(price / 100) / 100) +
            '万'
    }
    return price
}
const num2wString = (fen: any, fixed: number = 2) => {
    const price = parseFloat(fen || 0);
    if (price > 9999) {
        return (price / 10000).toFixed(fixed) +
            '万'
    }
    return price
}
// 数字取整数位
const num2inte = (val: any) => {
    val = val + '';
    let num = parseInt(val);//避免字符串带有字母等符号
    if (isNaN(num)) {
        return 0;
    }
    return num;

};

// 数字取小数位  bit:保留小数位
const num2decimal = (val: any, bit: number = 2) => {
    let s = val.toString();
    let rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + bit) {
        s += '0';
    }
    s = s.split('.')[1]
    return s;

};

//时间戳转时间格式 fmt格式形式为 yyyy:MM:dd / yyyy-MM-dd /  MM:dd hh:mm:ss
const dataFormat = (value: any, fmt: string) => {
    let valStr = value + "";
    if (valStr.length == 10) {
        value = value * 1000;
    }
    let getDate = new Date(value);
    let o: any = {
        "M+": getDate.getMonth() + 1,
        "d+": getDate.getDate(),
        "h+": getDate.getHours(),
        "m+": getDate.getMinutes(),
        "s+": getDate.getSeconds(),
        "q+": Math.floor((getDate.getMonth() + 3) / 3),
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            let str = o[k] + "";
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padleftZero(str))
        }
    }
    return fmt;
};
function padleftZero(str: any) {
    return ('00' + str).substr(str.length)
}
//兼容浏览器webp | png
const filterImg = (src: string) => {
    if (!src) return ''
    return addOssWebpWithImg(String(src))
}
export {
    fen2yuan,
    num2wString,
    num2inte,
    num2decimal,
    dataFormat,
    filterImg,
};